import de from './de/translation.json';
import en from './en/translation.json';
import es from './es/translation.json';
import nl from './nl/translation.json';

const translations = {
  de, en, es, nl,
};

export default translations;
